import React, { useRef } from "react";

function AdditionalInformation({ items = [], onSubmit }) {
	const nameRef = useRef();
	return (
		<>
			<form
				onSubmit={evt => {
					evt.preventDefault();
					onSubmit({
						name: nameRef.current.value
					});
					nameRef.current.value = "";
					nameRef.current.focus();
				}}
			>
				<div className="form-group">
					<label htmlFor="color-score-id">Name *</label>
					<input
						type="text"
						id="color-score-id"
						name="color-score-id"
						ref={nameRef}
						required
						className="form-control input-height"
						placeholder="enter name"
					/>
				</div>
				<div className="form-group text-right">
					<button
						type="submit"
						className="mdl-button mdl-button--raised mdl-js-ripple-effect m-l-10 m-t-20 btn-circle btn-success"
					>
						Add
						<i className="material-icons">arrow_right_alt</i>
					</button>
				</div>
			</form>
			<h4 className="text-success">List</h4>
			<ol>
				{items.map((a, i) => (
					<li key={i}>{a}</li>
				))}
			</ol>
			{!items.length && <h5 className="text-pink">No Additional properties</h5>}
		</>
	);
}
export default AdditionalInformation;
